import { styled } from "@mui/material/styles";

const Root = styled("div")(({ theme }) => ({
  textAlign: "center",
  padding: "50px",
  margin: "0px 100px",
  [theme.breakpoints.down("md")]: {
    padding: "20px",
    margin: "0px 10px",
  },
}));
const OneColumn = styled("div")(({ theme }) => ({
  margin: "auto",
  marginBottom: "30px",
  borderRadius: "20px",
  padding: "15px",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
  },
}));
export { Root, OneColumn };
